import PriceInfo from './pages/PriceInfo'
import PriceInfoBankproduct from './pages/PriceInfo/PriceInfoBankproduct'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './styles/styx.scss'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<PriceInfo />} />
        <Route path="/prisskyltning.html" element={<PriceInfoBankproduct />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
